import styled from "styled-components"
import { mobile, tablet, medScreen } from "../../Responsive"

export const Container = styled.div`
   background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
   padding: 50px;
   display: flex;

   ${tablet({ padding: "10px" })}
   ${mobile({ flexDirection: "column" })}
`

export const ImageContainer = styled.div`
   flex: 1.5;
`

export const InfoContainer = styled.div`
   flex: 1;
   padding: 0px 50px;

   ${tablet({ padding: "10px" })}
`

export const Title = styled.h1`
   font-weight: 200;
`

export const Description = styled.p`
   margin: 20px 0px;
`

export const Price = styled.span`
   font-weight: 100;
   font-size: var(--fontXL);
`

export const AttributeContainer = styled.div`
   margin: 30px 0px;
   display: flex;
   justify-content: space-between;

   ${tablet({ flexDirection: "column", margin: "0px 0px" })}
   ${mobile({ flexDirection: "column", margin: "0px 0px" })}
`

export const Attribute = styled.div`
   display: flex;
   align-items: center;
   margin-right: 10px;

   ${tablet({ margin: "10px 0px" })}
   ${mobile({ margin: "10px 0px" })}
`

export const AttributeTitle = styled.span`
   margin-right: 10px;
   font-size: var(--fontL);
   font-weight: 200;

   @media screen and (max-width: ${medScreen}) {
      font-size: var(--fontM);
   }
`

export const AttributeLabel = styled.div`
   padding: 10px;
   margin-right: 20px;
   font-size: var(--fontM);
   background-color: transparent;
   border: 1.5px solid var(--secondary);

   @media screen and (max-width: ${medScreen}) {
      font-size: var(--fontS);
   }
`

export const RoundBorder = styled.div`
   width: 50px;
   height: 50px;
   border-radius: 50%;
   border: 1.5px solid var(--${(props) => props.selected});
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 0px 5px;
`

export const FilterTexture = styled.div`
   width: 40px;
   height: 40px;
   border-radius: 50%;
   background-image: url(${(props) => props.texture});
   background-size: 40px;
   cursor: pointer;
   z-index: 1;
`

export const FilterColor = styled.div`
   width: 40px;
   height: 40px;
   border-radius: 50%;
   background-image: linear-gradient(
      to bottom right,
      var(--${(props) => props.color1}) 50%,
      var(--${(props) => props.color2}) 50%
   );
   z-index: 2;
`

export const FilterSize = styled.div`
   width: 40px;
   height: 40px;
   border-radius: 50%;
   color: var(--secondary);
   display: flex;
   align-items: center;
   justify-content: center;
   text-align: center;
   z-index: 3;
`

export const DimensionsContainer = styled.div`
   width: 330px;
   position: relative;
   font-size: var(--fontS);

   ${tablet({ width: "280px" })}
`

export const ImageSize = styled.img`
   width: 100%;
   border-radius: 20px;
   filter: invert(${(props) => props.filter});
   background-color: #312523;
`

export const TempleLength = styled.div`
   position: absolute;
   top: 71%;
   left: 20%;
   z-index: 3;
`

export const LensHeigth = styled.div`
   position: absolute;
   top: 41%;
   left: 94%;
   z-index: 3;
`

export const LensWidth = styled.div`
   position: absolute;
   top: 11%;
   left: 80%;
   z-index: 3;
`

export const Nose = styled.div`
   position: absolute;
   top: 11%;
   left: 70%;
   z-index: 3;
`

export const DistanceBetweenTemples = styled.div`
   position: absolute;
   top: 71%;
   left: 69%;
   z-index: 3;
`

export const AddContainer = styled.div`
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: space-between;

   ${mobile({ flexDirection: "column" })}
`

export const AmountContainer = styled.div`
   display: flex;
   align-items: center;
`

export const ButtonWrapper = styled.div`
   width: 35%;

   ${mobile({ width: "80%" })}
`

export const Amount = styled.div`
   font-weight: 700;
   width: 30px;
   height: 30px;
   border-radius: 10px;
   border: 1.5px solid var(--secondary);
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 0px 5px;
`

export const Icon = styled.div`
   width: 60px;
   height: 60px;
   border-radius: 50%;
   background-color: ${({ theme }) => theme.highLight};
   color: var(--secondary);
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 10px;
   transition: all 0.5s ease;
   cursor: pointer;

   &:hover {
      color: var(--primary);
      transform: scale(1.1);
   }
`
